<template>
    <div>
        <div v-if="RoundFunctions.hasEndDatePassed(round)" class="row justify-content-center round-details mb-3">
            <span class="round-details-header">{{ selectedLeague }} | {{ RoundFunctions.getDay(round.RoundStartDate) }} {{ RoundFunctions.getMonth(round.RoundStartDate) }} | {{ RoundFunctions.getTime(round.RoundStartDate) }}</span>
        </div>
        <div v-if="RoundFunctions.hasEndDatePassed(round)" class="row justify-content-center mb-4">
            <div class="col-11 col-md-6 round-container-soccer"
                 v-on:click="RoundFunctions.onRoundClicked(round, selectedSport)">
                <div class="row justify-content-center">
                    <h5>SELECT {{ round.RoundName || `${selectedLeague} Round` }}</h5>
                </div>
                <div class="row justify-content-center">
            <span>Round Ends: {{ RoundFunctions.getDay(round.RoundEndDate) }} {{
                RoundFunctions.getMonth(round.RoundEndDate)
              }} {{ RoundFunctions.getTime(round.RoundEndDate) }}</span>
                </div>
                <div class="has-active-predictions-sidebar" v-if="round.HasPredictions">Edit Predictions</div>
            </div>
        </div>
        <hr v-if="RoundFunctions.hasEndDatePassed(round)" class="line-break">
    </div>
</template>

<script>
    import RoundFunctions from "../functions/roundFunctions";
    import {mapState} from "vuex";

    export default {
        name: "SoccerRound",
        props: {
            round: {
                type: Object
            },
        },
        data() {
            return {
                RoundFunctions: RoundFunctions
            }
        },
        computed: mapState(['selectedSport', 'sportsWithActiveRounds', 'selectedLeague']),
    }
</script>

<style scoped lang="scss">
    .line-break {
        color: $line-break-color;
    }

    .round-container {
        color: $body-text-color;
    }

    h5 {
        color: $round-details-text-color;
        font-weight: 600;
    }

    h4  {
        color: $round-details-text-color;
        font-weight: 500;
        margin-bottom: 0;
    }

    .round-container-soccer {
        color: $round-details-text-color;
        padding: 1rem 0;
        background-color: $round-container-background-color;
        border-radius: 5px;
    }

    .round-details-header {
        font-size: 1.1rem;
    }

    .has-active-predictions-sidebar {
        color: black;
        font-size: 0.6rem;
        font-weight: 600;
        position: absolute;
        display: flex;
        width: 4vw;
        right: 0;
        top: 0;
        flex-direction: column;
        justify-content: center;
        align-content: center;
        height: 100%;
        writing-mode: vertical-rl;
        background-color: $sports-icon-hasPredictions-color;
        border-radius: 0 5px 5px 0;
    }
</style>
